module.exports = __webpack_public_path__ + "static/media/20ECE4.1f5d5a88.jpg";